import { colors } from "@mui/material";

import theme from "@theme/index";

const menuWidth = {
  xs: "100%",
};

const sidebarStyles = {
  menuItem: {
    ".menu-item-wrapper": {
      alignItems: "center",
      borderRadius: "8px",
      display: "flex",
      fontSize: 14,
      justifyContent: "start",
      pr: 2,
      transition: "background-color 0.1s ease-in-out",
      width: "100%",
    },
    ".svg-wrapper": {
      "& > svg": {
        fill: colors.grey[600],
      },
      alignItems: "center",
      display: "flex",
      height: 40,
      justifyContent: "center",
      lineHeight: 1,
      minWidth: 56,
      transition: "background-color 0.1s ease-in-out",
    },
    "&:not(.Mui-selected):hover": {
      ".menu-item-wrapper": {
        "& svg": {
          fill: theme.palette.primary.light,
        },
        backgroundColor: colors.grey[900],
      },
      color: theme.palette.common.white,
    },
    "&.Mui-selected": {
      ".menu-item-wrapper": {
        "& svg": {
          fill: theme.palette.primary.light,
        },
        backgroundColor: colors.grey[900],
      },
      color: theme.palette.common.white,
      fontWeight: "700 !important",
    },
    alignItems: "center",
    backgroundColor: "transparent !important",
    color: colors.grey[300],
    display: "flex",

    gap: theme.spacing(0.5),

    justifyContent: "center",
    p: theme.spacing(0),
    width: {
      md: "100%",
      xs: "80px",
    },
  },
  menuList: {
    display: "flex",
    flexDirection: {
      md: "column",
      xs: "row",
    },

    gap: theme.spacing(2),
    height: {
      md: "100%",
      xs: "auto",
    },
    width: "100%",
  },
  root: {
    height: {
      md: "100vh",
      xs: "auto",
    },
    left: 0,
    minWidth: menuWidth,
    width: menuWidth,
    zIndex: 1000,
  },
  sidebar: {
    alignItems: "center",
    alignSelf: "stretch",
    backgroundColor: theme.palette.secondary.main,

    display: "flex",
    flexDirection: {
      md: "column",
      xs: "row",
    },
    gap: 2,
    height: "100%",
    justifyContent: {
      md: "space-between",
      xs: "flex-start",
    },
    overflowX: {
      md: "hidden",
      xs: "auto",
    },
    px: 1,
    py: 3,
  },
};

export default sidebarStyles;
